export default {
  props: {
    value: String,
  },



  data() {
    return {
      target: null,
      activeIndex: null,
    }
  },



  computed: {
    classes() {
      return {
        'dn-tabs': true,
      }
    },
  },



  methods: {
    set(target) {
      this.target = target;
      this.activeIndex = this.$refs.content.$children.findIndex(i => i.id === this.target);
      this.$emit('input', target);
    },

    onItemDisabledChange(target, disabled) {
      if (!disabled) return;
      if (this.target === target) {
        this.set(null);
        this.$nextTick(() => {
          this.setInitialIndex();
        });
      }
    },

    setInitialIndex() {
      const activators = this.$slots.activators;
      if (!activators || !activators.length || !activators[0].componentInstance.$children) return;

      const bar = activators[0].componentInstance.$children;
      const i = bar.findIndex(t => {
        return t.$el.classList.contains('dn-tabs__item--active') && !t.$el.classList.contains('dn-tabs__item--disabled');
      });

      const defaultIndex = i !== -1 ? i : bar.findIndex(t => {
        return !t.$el.classList.contains('dn-tabs__item--disabled');
      });

      const tab = this.value || (bar[defaultIndex !== -1 ? defaultIndex : 0] || {}).action;
      tab && this.set(tab);
    },
  },



  watch: {
    value() {
      this.set(this.value);
    },
  },



  mounted() {
    this.setInitialIndex();
  },



  render(h) {
    const content = [];
    const slot    = [];
    const iter    = (this.$slots.default || []);

    iter.forEach(c => {
      if (!c.componentOptions) {
        slot.push(c)
      } else if (c.componentOptions.tag === 'dn-tabs-content') {
        content.push(c)
      } else {
        slot.push(c)
      }
    });

    const tabs = content.length ? h('dn-tabs-items', {
      ref: 'content',
    }, content) : null;

    return h('div', {
      'class': this.classes
    }, [slot, this.$slots.activators, tabs]);
  },
}



// WEBPACK FOOTER //
// ./src/js/ui/components/tabs/Tabs.js